import { render, staticRenderFns } from "./OfferParamsOpenSeminar.vue?vue&type=template&id=de2f865c&"
import script from "./OfferParamsOpenSeminar.vue?vue&type=script&lang=js&"
export * from "./OfferParamsOpenSeminar.vue?vue&type=script&lang=js&"
import style0 from "./OfferParamsOpenSeminar.vue?vue&type=style&index=0&id=de2f865c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports